export default __webpack_public_path__ + "static/media/love.7da6db36.avif";